"use client";

import { CircleAlert as AlertCircle, ArrowRight, Brain, Gem, MapPin, Smile, Sparkles, Users } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  icon: Users,
  title: "Guest Mobility",
  description: "Información en tiempo real para transporte interno.",
  href: "/EcosystemPage",
  popular: false
}, {
  icon: MapPin,
  title: "Excursion Control",
  description: "Seguimiento de excursiones y autobuses turísticos.",
  href: "/EcosystemPage",
  popular: false
}, {
  icon: Brain,
  title: "Operations Intelligence",
  description: "Información útil para recepción, restauración y operaciones.",
  href: "/EcosystemPage",
  popular: false
}];
export default function VisibilidadTotalEn3Niveles() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: footerRef,
    isVisible: footerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section className="py-16 bg-background overflow-hidden">
      <div className="container mx-auto px-4">
        <div ref={headerRef} className={`max-w-3xl mb-16 transition-all duration-1000 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <Badge variant="outline" className="mb-4 border-primary/20 text-primary uppercase tracking-widest">NUESTRAS SOLUCIONES</Badge>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-border transition-all duration-1000 delay-200 ${gridVisible ? "opacity-100" : "opacity-0"}`}>
          {services.map((service, i) => <div key={i} data-index={i} className="bg-background p-8 group hover:bg-accent/5 transition-colors duration-300 flex flex-col h-full">
              <div className="mb-6 inline-flex items-center justify-center size-12 bg-primary/5 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-500">
                <service.icon className="size-6" />
              </div>
              
              <div className="flex items-center gap-3 mb-4">
                <h3 className="text-xl font-medium tracking-tight">{service.title}</h3>
                {service.popular && <Badge variant="default" className="bg-accent text-accent-foreground text-[10px] px-1.5 py-0">
                    POPULAR
                  </Badge>}
              </div>
              
              <p className="text-muted-foreground mb-8 flex-grow leading-relaxed">
                {service.description}
              </p>

              <Button asChild variant="outline" className="w-full sm:w-auto group/btn">
                <Link to="/SolutionsPage">
                  Más Información
                  <ArrowRight className="ml-2 size-4 transition-transform group-hover/btn:translate-x-1" />
                </Link>
              </Button>
            </div>)}
        </div>
      </div>
    </section>;
}